/**
 * De querystring van de helpdeskfilters — op één plaats.
 *
 * Dezelfde omzetting stond woordelijk in `useHelpdeskDataLazy` én in
 * `useHelpdeskListPagination`, en met de weergave per gebouw erbij zou ze een
 * derde keer gekopieerd worden. Dan is het een kwestie van tijd voor een nieuw
 * filter in de ene lijst werkt en in de andere niet.
 *
 * @module Helpdesk/Shared/Utils/HelpdeskTicketParams
 */

import type { HelpdeskFilters } from "../hooks/useHelpdeskDataLazy";

export const buildHelpdeskTicketParams = (
  filters: HelpdeskFilters = {},
): Record<string, string> => {
  const params: Record<string, string> = {};

  if (filters.search) params.search = filters.search;
  if (filters.source?.length) params.source = filters.source.join(",");
  if (filters.status?.length) params.status = filters.status.join(",");
  if (filters.priority?.length) params.priority = filters.priority.join(",");
  if (filters.building?.length) params.building = filters.building.join(",");
  if (filters.unit?.length) params.unit = filters.unit.join(",");
  if (filters.label?.length) params.label = filters.label.join(",");
  if (filters.assignee?.length) params.assignee = filters.assignee.join(",");
  // Supplier names are free text and may contain commas or trailing spaces
  // (e.g. "D'hoedt, Hugo", "Tomasz "). Send as JSON so the exact names survive
  // the round-trip — a comma-join would corrupt the backend `cc.name IN (...)` match.
  if (filters.supplier?.length) params.supplier = JSON.stringify(filters.supplier);
  if (filters.dateFilter) params.dateFilter = filters.dateFilter;
  if (filters.hasUnansweredIncomingEmail !== undefined) {
    params.hasUnansweredIncomingEmail =
      filters.hasUnansweredIncomingEmail.toString();
  }
  if (filters.hasUnreadEmails !== undefined) {
    params.hasUnreadEmails = filters.hasUnreadEmails.toString();
  }

  return params;
};
